export default __webpack_public_path__ + "static/iso-27001-seal-a5a2c51b65e7126d9ca3857d28a299db.svg";